import React from 'react';
import { IndianRupee, CheckCircle2, Clock, AlertTriangle, TrendingUp } from 'lucide-react';
import { inr } from '../poPayment';

export default function POKpiStrip({ summary }) {
  const s = summary || {};
  const cards = [
    { key: 'total', label: 'Total PO value', value: inr(s.total), sub: `${s.count || 0} POs · avg ${inr(s.average)}`, icon: IndianRupee, tone: 'text-fuchsia-700 bg-fuchsia-50' },
    { key: 'paid', label: 'Paid', value: inr(s.paid), sub: s.total ? `${Math.round((s.paid / s.total) * 100)}% of value` : '—', icon: CheckCircle2, tone: 'text-emerald-700 bg-emerald-50' },
    { key: 'pending', label: 'Pending', value: inr(s.pending), sub: 'Not yet due', icon: Clock, tone: 'text-amber-700 bg-amber-50' },
    { key: 'overdue', label: 'Overdue', value: inr(s.overdue), sub: `${s.overdue_count || 0} past due date`, icon: AlertTriangle, tone: 'text-red-700 bg-red-50' },
    { key: 'margin', label: 'Margin', value: s.margin_pct == null ? '—' : `${s.margin_pct}%`, sub: `${inr(s.margin)} on ${s.costed_count || 0} costed POs`, icon: TrendingUp, tone: 'text-slate-700 bg-slate-100' },
  ];
  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 sm:gap-4 mb-6">
      {cards.map((c, i) => (
        <div key={c.key} className="soft-card p-4 animate-in fade-in slide-in-from-bottom-1" style={{ animationDelay: `${i * 50}ms` }} data-testid={`po-kpi-${c.key}`}>
          <div className={`w-8 h-8 rounded-lg flex items-center justify-center mb-3 ${c.tone}`}><c.icon className="w-4 h-4" /></div>
          <p className="text-[11px] uppercase tracking-wider font-semibold text-slate-500">{c.label}</p>
          <p className="text-xl font-bold text-[#1a1a2e] tabular-nums mt-0.5" data-testid={`po-kpi-${c.key}-value`}>{c.value}</p>
          <p className="text-[11px] text-slate-500 mt-0.5 truncate">{c.sub}</p>
        </div>
      ))}
    </div>
  );
}
